// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Workshops & Events ──────────────────────────────────
   Leans on the shared admin classes (acard, a-btn, ars__field,
   aap__stat-*); only what's particular to this page lives here. */

.awk__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin: 1.25rem 0;
}

.awk__search {
  flex: 1 1 14rem;
  max-width: 22rem;
}

.awk__toolbar .a-btn {
  margin-left: auto;
}

/* ── The list ── */
.awk__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.awk__card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.25rem;
}

.awk__card--past { opacity: 0.6; }

.awk__card-main { min-width: 0; }

.awk__card-when {
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--admin-rust);
  margin: 0 0 0.3rem;
}

.awk__card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 1.05rem;
  margin: 0 0 0.35rem;
  color: #1e2a1e;
}

.awk__card-summary {
  font-size: 0.88rem;
  color: #55504a;
  margin: 0 0 0.35rem;
  max-width: 48rem;
}

.awk__card-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  font-size: 0.8rem;
  color: #6b6258;
  margin: 0;
}

.awk__card-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;
}

/* ── Small controls ── */
.awk__mini {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem !important;
  font-size: 0.78rem !important;
}

.awk__icon-btn {
  background: #f3f4f0;
  border: none;
  border-radius: 6px;
  width: 2rem;
  height: 2rem;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: #6b6258;
  font-size: 0.95rem;
}
.awk__icon-btn:hover { background: #e7e8e2; color: #1e2a1e; }
.awk__icon-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.awk__icon-btn--danger:hover { background: #fee2e2; color: #b91c1c; }

/* ── Badges ── */
.awk__status {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
}
.awk__status--published { background: rgba(22, 163, 74, 0.12); color: #15803d; }
.awk__status--draft     { background: rgba(107, 98, 88, 0.14); color: #6b6258; }
.awk__status--cancelled { background: rgba(220, 38, 38, 0.1);  color: #b91c1c; }
.awk__status--confirmed { background: rgba(22, 163, 74, 0.12); color: #15803d; }
.awk__status--waitlist  { background: rgba(var(--admin-rust-rgb), 0.12); color: #c2410c; }

.awk__pill {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: #f3f4f0;
  color: #6b6258;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
}

/* ── Empty state ── */
.awk__empty-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 3rem 1.5rem;
  text-align: center;
  color: #6b6258;
}
.awk__empty-card svg { font-size: 2rem; opacity: 0.4; }
.awk__empty-card p { margin: 0; }

.awk__empty {
  text-align: center;
  color: #6b6258;
  padding: 2rem 0;
  margin: 0;
}

/* ── Editor and roster dialogs ── */
/* The shared modal sets \`width: min(420px, 90vw)\`. That's a width, not a
   max-width, so a max-width here could never widen it — and 420px can't
   hold two datetime-local inputs side by side, which is what made this
   form overflow sideways. Overriding the width itself. */
.awk__modal {
  width: min(620px, 94vw) !important;
  max-width: none;
  max-height: 88vh;
  overflow-y: auto;
}

/* Grid children default to min-width:auto, so a wide control pushes the
   column out instead of the column constraining it. */
.awk__row > *,
.awk__modal .ars__field { min-width: 0; }
.awk__modal input,
.awk__modal textarea,
.awk__modal select { max-width: 100%; box-sizing: border-box; }

.awk__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem;
}

.awk__hint {
  font-size: 0.76rem;
  color: #6b6258;
  margin: -0.3rem 0 0.85rem;
}
.awk__hint--top { margin: 0 0 1rem; }

.awk__check {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  font-size: 0.85rem;
  color: #1e2a1e;
  margin-bottom: 0.9rem;
  cursor: pointer;
}
.awk__check input { margin-top: 0.2rem; }
.awk__check em { font-style: normal; color: #6b6258; }

.awk__error {
  background: rgba(220, 38, 38, 0.08);
  color: #b91c1c;
  border-radius: 6px;
  padding: 0.6rem 0.8rem;
  font-size: 0.85rem;
  margin: 0 0 0.85rem;
}

.awk__actions {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}

/* ── Roster ── */
.awk__roster {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: 46vh;
  overflow-y: auto;
}

.awk__signup {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  background: #fafaf7;
  border: 1px solid #ececE4;
  border-radius: 8px;
  padding: 0.7rem 0.85rem;
}
.awk__signup--cancelled { opacity: 0.55; }

.awk__signup-who { min-width: 0; }

.awk__signup-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
  font-weight: 700;
  font-size: 0.9rem;
  color: #1e2a1e;
  margin: 0 0 0.2rem;
}

.awk__signup-contact {
  font-size: 0.8rem;
  color: #6b6258;
  margin: 0;
  word-break: break-word;
}
.awk__signup-contact a { color: #6b6258; }

.awk__signup-notes {
  font-size: 0.8rem;
  color: #55504a;
  font-style: italic;
  margin: 0.3rem 0 0;
}

.awk__signup-actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
}

@media (max-width: 640px) {
  .awk__row { grid-template-columns: 1fr; }
}

@media (max-width: 720px) {
  .awk__card { flex-direction: column; }
  .awk__card-actions { width: 100%; justify-content: flex-end; }
  .awk__row { grid-template-columns: 1fr; }
  .awk__toolbar .a-btn { margin-left: 0; }
  .awk__search { max-width: none; }
}

/* More people confirmed than there are places — staff did that on
   purpose, but it shouldn't read like an arithmetic bug. */
.awk__over { color: #c2410c; font-weight: 700; }

.awk__notice {
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
  color: #6b6258;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminWorkshops.css"],"names":[],"mappings":"AAAA;;kEAEkE;;AAElE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA,mBAAmB,YAAY,EAAE;;AAEjC,kBAAkB,YAAY,EAAE;;AAEhC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;;AAEpE,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;AACtB;AACA,0BAA0B,mCAAmC,EAAE,cAAc,EAAE;AAC/E,0BAA0B,mCAAmC,EAAE,cAAc,EAAE;AAC/E,0BAA0B,kCAAkC,GAAG,cAAc,EAAE;AAC/E,0BAA0B,mCAAmC,EAAE,cAAc,EAAE;AAC/E,0BAA0B,6CAA6C,EAAE,cAAc,EAAE;;AAEzF;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;AACA,uBAAuB,eAAe,EAAE,YAAY,EAAE;AACtD,qBAAqB,SAAS,EAAE;;AAEhC;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,oCAAoC;AACpC;;;yDAGyD;AACzD;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;sDACsD;AACtD;0BAC0B,YAAY,EAAE;AACxC;;qBAEqB,eAAe,EAAE,sBAAsB,EAAE;;AAE9D;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;AACA,kBAAkB,gBAAgB,EAAE;;AAEpC;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA,oBAAoB,kBAAkB,EAAE;AACxC,iBAAiB,kBAAkB,EAAE,cAAc,EAAE;;AAErD;EACE,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;AACA,0BAA0B,aAAa,EAAE;;AAEzC,mBAAmB,YAAY,EAAE;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;AACA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY,0BAA0B,EAAE;AAC1C;;AAEA;EACE,aAAa,sBAAsB,EAAE;EACrC,qBAAqB,WAAW,EAAE,yBAAyB,EAAE;EAC7D,YAAY,0BAA0B,EAAE;EACxC,uBAAuB,cAAc,EAAE;EACvC,eAAe,eAAe,EAAE;AAClC;;AAEA;2DAC2D;AAC3D,aAAa,cAAc,EAAE,gBAAgB,EAAE;;AAE/C;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* ── Workshops & Events ──────────────────────────────────\n   Leans on the shared admin classes (acard, a-btn, ars__field,\n   aap__stat-*); only what's particular to this page lives here. */\n\n.awk__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  margin: 1.25rem 0;\n}\n\n.awk__search {\n  flex: 1 1 14rem;\n  max-width: 22rem;\n}\n\n.awk__toolbar .a-btn {\n  margin-left: auto;\n}\n\n/* ── The list ── */\n.awk__list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.awk__card {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.1rem 1.25rem;\n}\n\n.awk__card--past { opacity: 0.6; }\n\n.awk__card-main { min-width: 0; }\n\n.awk__card-when {\n  font-size: 0.74rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--admin-rust);\n  margin: 0 0 0.3rem;\n}\n\n.awk__card-title {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  font-size: 1.05rem;\n  margin: 0 0 0.35rem;\n  color: #1e2a1e;\n}\n\n.awk__card-summary {\n  font-size: 0.88rem;\n  color: #55504a;\n  margin: 0 0 0.35rem;\n  max-width: 48rem;\n}\n\n.awk__card-meta {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n  color: #6b6258;\n  margin: 0;\n}\n\n.awk__card-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-shrink: 0;\n}\n\n/* ── Small controls ── */\n.awk__mini {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.4rem 0.75rem !important;\n  font-size: 0.78rem !important;\n}\n\n.awk__icon-btn {\n  background: #f3f4f0;\n  border: none;\n  border-radius: 6px;\n  width: 2rem;\n  height: 2rem;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  color: #6b6258;\n  font-size: 0.95rem;\n}\n.awk__icon-btn:hover { background: #e7e8e2; color: #1e2a1e; }\n.awk__icon-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n.awk__icon-btn--danger:hover { background: #fee2e2; color: #b91c1c; }\n\n/* ── Badges ── */\n.awk__status {\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n}\n.awk__status--published { background: rgba(22, 163, 74, 0.12); color: #15803d; }\n.awk__status--draft     { background: rgba(107, 98, 88, 0.14); color: #6b6258; }\n.awk__status--cancelled { background: rgba(220, 38, 38, 0.1);  color: #b91c1c; }\n.awk__status--confirmed { background: rgba(22, 163, 74, 0.12); color: #15803d; }\n.awk__status--waitlist  { background: rgba(var(--admin-rust-rgb), 0.12); color: #c2410c; }\n\n.awk__pill {\n  font-size: 0.66rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: #f3f4f0;\n  color: #6b6258;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n}\n\n/* ── Empty state ── */\n.awk__empty-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 3rem 1.5rem;\n  text-align: center;\n  color: #6b6258;\n}\n.awk__empty-card svg { font-size: 2rem; opacity: 0.4; }\n.awk__empty-card p { margin: 0; }\n\n.awk__empty {\n  text-align: center;\n  color: #6b6258;\n  padding: 2rem 0;\n  margin: 0;\n}\n\n/* ── Editor and roster dialogs ── */\n/* The shared modal sets `width: min(420px, 90vw)`. That's a width, not a\n   max-width, so a max-width here could never widen it — and 420px can't\n   hold two datetime-local inputs side by side, which is what made this\n   form overflow sideways. Overriding the width itself. */\n.awk__modal {\n  width: min(620px, 94vw) !important;\n  max-width: none;\n  max-height: 88vh;\n  overflow-y: auto;\n}\n\n/* Grid children default to min-width:auto, so a wide control pushes the\n   column out instead of the column constraining it. */\n.awk__row > *,\n.awk__modal .ars__field { min-width: 0; }\n.awk__modal input,\n.awk__modal textarea,\n.awk__modal select { max-width: 100%; box-sizing: border-box; }\n\n.awk__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.85rem;\n}\n\n.awk__hint {\n  font-size: 0.76rem;\n  color: #6b6258;\n  margin: -0.3rem 0 0.85rem;\n}\n.awk__hint--top { margin: 0 0 1rem; }\n\n.awk__check {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.6rem;\n  font-size: 0.85rem;\n  color: #1e2a1e;\n  margin-bottom: 0.9rem;\n  cursor: pointer;\n}\n.awk__check input { margin-top: 0.2rem; }\n.awk__check em { font-style: normal; color: #6b6258; }\n\n.awk__error {\n  background: rgba(220, 38, 38, 0.08);\n  color: #b91c1c;\n  border-radius: 6px;\n  padding: 0.6rem 0.8rem;\n  font-size: 0.85rem;\n  margin: 0 0 0.85rem;\n}\n\n.awk__actions {\n  display: flex;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n}\n\n/* ── Roster ── */\n.awk__roster {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  max-height: 46vh;\n  overflow-y: auto;\n}\n\n.awk__signup {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  background: #fafaf7;\n  border: 1px solid #ececE4;\n  border-radius: 8px;\n  padding: 0.7rem 0.85rem;\n}\n.awk__signup--cancelled { opacity: 0.55; }\n\n.awk__signup-who { min-width: 0; }\n\n.awk__signup-name {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  font-weight: 700;\n  font-size: 0.9rem;\n  color: #1e2a1e;\n  margin: 0 0 0.2rem;\n}\n\n.awk__signup-contact {\n  font-size: 0.8rem;\n  color: #6b6258;\n  margin: 0;\n  word-break: break-word;\n}\n.awk__signup-contact a { color: #6b6258; }\n\n.awk__signup-notes {\n  font-size: 0.8rem;\n  color: #55504a;\n  font-style: italic;\n  margin: 0.3rem 0 0;\n}\n\n.awk__signup-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-shrink: 0;\n}\n\n@media (max-width: 640px) {\n  .awk__row { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 720px) {\n  .awk__card { flex-direction: column; }\n  .awk__card-actions { width: 100%; justify-content: flex-end; }\n  .awk__row { grid-template-columns: 1fr; }\n  .awk__toolbar .a-btn { margin-left: 0; }\n  .awk__search { max-width: none; }\n}\n\n/* More people confirmed than there are places — staff did that on\n   purpose, but it shouldn't read like an arithmetic bug. */\n.awk__over { color: #c2410c; font-weight: 700; }\n\n.awk__notice {\n  padding: 1rem 1.25rem;\n  margin-bottom: 1rem;\n  color: #6b6258;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
